import bg from "../assets/images/background/image-2.jpg";

const parallaxSection = {
  bg,
  icon: "flaticon-app-development",
  title:
    "Business greatness arises from team collaboration, not individual effort.  ",
  title2: "Remarkable achievements are a team endeavor.",
};

export const parallaxPage = [
  {
    id: 1,
    bg: "parallax-bg-1-1.jpg",
    title: "Hand drawn Painting",
  },
  {
    id: 2,
    bg: "parallax-bg-1-2.jpg",
    title: "Creative Shop branding",
  },
  {
    id: 3,
    bg: "parallax-bg-1-3.jpg",
    title: "Stunning Photography",
  },
  {
    id: 4,
    bg: "parallax-bg-1-4.jpg",
    title: "Illustration art Work",
  },
];

export default parallaxSection;
